function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <div id="fh5co-footer">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <p>&copy; {currentYear} Pablo Magro Gaspar. All Rights Reserved. <br />Designed by Brick Samurai</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
